// compassionProgramme.ts — the self-compassion "soft landing" alt route.
//
// Generated from the Thinkific export by scripts/build-compassion-app-data.cjs
// (→ compassion.generated.json). Every lesson is an article step; narrations
// carry an audio_url so LessonText shows the audio player on top. The meditations
// are NOT here — they live in the "Meditation videos" tab in Your stuff.
//
// Shares the one progress store with the main programme; its step/module ids are
// all `sc-` prefixed so the two tracks never collide.
import type { Programme } from '@/types';
import generated from './compassion.generated.json';

export const COMPASSION_PROGRAMME = generated as unknown as Programme;
